import { FC, useMemo, useState } from 'react';
import { useAtomValue } from 'jotai';
import { loadable } from 'jotai/utils';
import { Tab, Tabs } from '@mui/material';
import { styled } from '@mui/material/styles';
import { personState } from '../../../../services/state/PersonStateJ';
import { ErrorOccurredMessage } from '../../components/Messages/HelpMessage';
import { Loader } from '../../../../components/Loader/Loader';
import { PersonGeneralInfo } from './PersonGeneralInfo';
import { PersonWorkHistory } from './PersonWorkHistory';
import { EducationHistory } from './EducationHistory';

const Main = styled('main')`
  padding: 1rem 1.5rem;
`;

export const PersonTabs = [
  { value: 0, label: 'General' },
  { value: 1, label: 'Work History' },
  { value: 2, label: 'Education History' },
];

interface IPersonMainContentProps {
  personId: number;
  companyId: number;
}

export const PersonMainContent: FC<IPersonMainContentProps> = ({ personId, companyId }) => {
  const personLoadableAtom = useMemo(() => loadable(personState(personId)), [personId]);
  const personLoadable = useAtomValue(personLoadableAtom);
  const person = personLoadable.state === 'hasData' ? personLoadable.data : undefined;

  const [activeTab, setActiveTab] = useState(0);

  if (personLoadable.state === 'hasError') {
    return <ErrorOccurredMessage />;
  }
  if (personLoadable.state === 'loading') {
    return <Loader />;
  }
  if (!person) {
    return null;
  }

  return (
    <Main>
      <Tabs
        variant='scrollable'
        scrollButtons='auto'
        value={activeTab}
        onChange={(e, tab) => setActiveTab(tab)}
        style={{ marginBottom: '1rem' }}
      >
        {PersonTabs.map((t) => (
          <Tab
            key={t.value}
            value={t.value}
            label={t.label}
            style={{ paddingLeft: 0, marginRight: '1rem' }}
          />
        ))}
      </Tabs>
      {activeTab === 0 && <PersonGeneralInfo person={person} companyId={companyId} />}
      {activeTab === 1 && <PersonWorkHistory person={person} />}
      {activeTab === 2 && <EducationHistory person={person} />}
    </Main>
  );
};
